import _ from "lodash";
import { isValuePresent } from "../../utils/builderUtils";

export const buildProductHeroStylesheet = (builder, device, cta, element, variant) => {
    let options = { ...element.options };

    const productLayout = options["products-layout"];

    let innerPadding;
    if (options["products-item-padding"]) {
      const paddingValue = parseInt(options["products-item-padding"]);
      innerPadding = `${paddingValue}px`;
    }

    let innerPaddingMobile;
    if (options["products-item-padding-mobile"]) {
      const paddingValueMobile = parseInt(
        options["products-item-padding-mobile"]
      );
      innerPaddingMobile = `${paddingValueMobile}px`;
    }

    let outerPadding;
    if (options["products-padding"]) {
      const paddingValue = parseInt(options["products-padding"]);
      outerPadding = `${paddingValue}px`;
    }

    let outerPaddingMobile;
    if (options["products-padding-mobile"]) {
      const paddingValueMobile = parseInt(options["products-padding-mobile"]);
      outerPaddingMobile = `${paddingValueMobile}px`;
    }

    let verticalMargin;
    if (options["products-margin-vertical"]) {
      const marginValue = parseInt(options["products-margin-vertical"]);
      verticalMargin = `${marginValue}px`;
    }

    let verticalMarginMobile;
    if (options["products-margin-vertical-mobile"]) {
      const marginValueMobile = parseInt(
        options["products-margin-vertical-mobile"]
      );
      verticalMarginMobile = `${marginValueMobile}px`;
    }

    let borderRadius = "";
    if (options["products-item-radius"] == "cf-not-rounded") {
      borderRadius = "0px";
    }
    if (options["products-item-radius"] == "cf-slightly-rounded") {
      borderRadius = "4px";
    }
    if (options["products-item-radius"] == "cf-fully-rounded") {
      borderRadius = "100px";
    }
    if (options["products-item-radius"] == "custom") {
      borderRadius = "";
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
        (side) => {
          borderRadius += `${
            _.isNil(options["products-item-radius-" + side]) == false
              ? options["products-item-radius-" + side]
              : "4"
          }px `;
        }
      );
    }

    let boxShadow;

    if (options["products-item-shadow"] == "None") {
      boxShadow = "none";
    }

    if (options["products-item-shadow"] == "soft") {
      boxShadow = "0 5px 15px 0 rgb(179 179 179 / 78%)";
    }

    if (options["products-item-shadow"] == "hard") {
      boxShadow = "-5px 5px 0 0 rgb(0 0 0 / 10%)";
    }

    if (options["products-item-shadow"] == "custom") {
      boxShadow = "";
      boxShadow +=
        (options["products-item-shadow-horizontal-distance"]
          ? `${options["products-item-shadow-horizontal-distance"]}px`
          : "0px") + " ";

      boxShadow +=
        (options["products-item-shadow-vertical-distance"]
          ? `${options["products-item-shadow-vertical-distance"]}px`
          : "0px") + " ";

      boxShadow +=
        (options["products-item-shadow-blur-radius"]
          ? `${options["products-item-shadow-blur-radius"]}px`
          : "0px") + " ";

      boxShadow +=
        (options["products-item-shadow-spread-radius"]
          ? `${options["products-item-shadow-spread-radius"]}px`
          : "0px") + " ";

      boxShadow +=
        (options["products-item-shadow-color"]
          ? options["products-item-shadow-color"]
          : "rgba(0,0,0, 0.35)") + " ";
    }

    let buttonBorderRadius = "";
    if (options["button-radius"] == "cf-not-rounded") {
      buttonBorderRadius = "0px";
    }
    if (options["button-radius"] == "cf-slightly-rounded") {
      buttonBorderRadius = "4px";
    }
    if (options["button-radius"] == "cf-fully-rounded") {
      buttonBorderRadius = "100px";
    }
    if (options["button-radius"] == "custom") {
      buttonBorderRadius = "";
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
        (side) => {
          buttonBorderRadius += `${
            _.isNil(options["button-radius-" + side]) == false
              ? options["button-radius-" + side]
              : "4"
          }px `;
        }
      );
    }

    let buttonShadow;
    let buttonShadowHover;

    if (options["button-shadow"] == "None") {
      buttonShadow = "none";
    }

    if (options["button-shadow"] == "soft") {
      buttonShadow = "0 5px 15px 0 rgb(179 179 179 / 78%)";
    }

    if (options["button-shadow"] == "hard") {
      buttonShadow = "-5px 5px 0 0 rgb(0 0 0 / 10%)";
    }

    if (options["button-shadow"] == "custom") {
      buttonShadow = "";
      buttonShadow +=
        (options["button-shadow-horizontal-distance"]
          ? `${options["button-shadow-horizontal-distance"]}px`
          : "0px") + " ";

      buttonShadow +=
        (options["button-shadow-vertical-distance"]
          ? `${options["button-shadow-vertical-distance"]}px`
          : "0px") + " ";

      buttonShadow +=
        (options["button-shadow-blur-radius"]
          ? `${options["button-shadow-blur-radius"]}px`
          : "0px") + " ";

      buttonShadow +=
        (options["button-shadow-spread-radius"]
          ? `${options["button-shadow-spread-radius"]}px`
          : "0px") + " ";

      buttonShadow +=
        (options["button-shadow-color"]
          ? options["button-shadow-color"]
          : "rgba(0,0,0, 0.35)") + " ";

      buttonShadowHover =
        buttonShadow +
        (options["button-hover-shadow-color"]
          ? options["button-hover-shadow-color"]
          : options["button-shadow-color"]
          ? options["button-shadow-color"]
          : "rgba(0,0,0, 0.35)");

      buttonShadow += options["button-shadow-inset"] == "true" ? "inset" : "";
      buttonShadowHover +=
        options["button-shadow-inset"] == "true" ? "inset" : "";
    }

    let buttonFont;
    if (options["button-font"] && options["button-font"] !== "theme") {
      buttonFont = options["button-font"];
    }

    let buttonFontWeight;
    if (
      options["button-font-weight"] &&
      options["button-font-weight"] !== "theme"
    ) {
      buttonFontWeight = options["button-font-weight"];
    }

    let buttonFontSize;
    if (options["button-font-size"]) {
      buttonFontSize = options["button-font-size"];
    }

    let imageBorderRadius = "";
    if (options["products-image-corner-rounding"] == "cf-not-rounded") {
      imageBorderRadius = "0px";
    }
    if (options["products-image-corner-rounding"] == "cf-slightly-rounded") {
      imageBorderRadius = "4px";
    }
    if (options["products-image-corner-rounding"] == "cf-fully-rounded") {
      imageBorderRadius = "100px";
    }
    if (options["products-image-corner-rounding"] == "custom") {
      imageBorderRadius = "";
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
        (side) => {
          imageBorderRadius += `${
            _.isNil(options["products-image-corner-" + side]) == false
              ? options["products-image-corner-" + side]
              : "4"
          }px `;
        }
      );
    }

    let imageBadgePosition;
    if (element.options["products-image-badge-placement"] == "top-right") {
      imageBadgePosition = "top: 0; right: 0;";
    } else if (
      element.options["products-image-badge-placement"] == "top-left"
    ) {
      imageBadgePosition = "top: 0; left: 0;";
    } else if (
      element.options["products-image-badge-placement"] == "bottom-right"
    ) {
      imageBadgePosition = "bottom: 0; right: 0;";
    } else if (
      element.options["products-image-badge-placement"] == "bottom-left"
    ) {
      imageBadgePosition = "bottom: 0; left: 0;";
    }

    let imageBadgeBackground = element.options["products-image-badge-background"] || variant.options["products-hero-offer-badge-background"];

    let imageBadgeCornerRounding;
    if (options["products-image-badge-corner-rounding"] == "cf-not-rounded") {
      imageBadgeCornerRounding = "0px";
    }
    if (
      options["products-image-badge-corner-rounding"] == "cf-slightly-rounded"
    ) {
      imageBadgeCornerRounding = "4px";
    }
    if (options["products-image-badge-corner-rounding"] == "cf-fully-rounded") {
      imageBadgeCornerRounding = "100px";
    }
    if (options["products-image-badge-corner-rounding"] == "custom") {
      imageBadgeCornerRounding = "";
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
        (side) => {
          imageBadgeCornerRounding += `${
            _.isNil(options["products-image-badge-corner-" + side]) == false
              ? options["products-image-badge-corner-" + side]
              : "4"
          }px `;
        }
      );
    }

    let themeImageBadgeCornerRounding;
    if (variant.options["products-hero-offer-badge-corner-rounding"] == "cf-not-rounded") {
      themeImageBadgeCornerRounding = "0px";
    }
    if (
      variant.options["products-hero-offer-badge-corner-rounding"] == "cf-slightly-rounded"
    ) {
      themeImageBadgeCornerRounding = "4px";
    }
    if (variant.options["products-hero-offer-badge-corner-rounding"] == "cf-fully-rounded") {
      themeImageBadgeCornerRounding = "100px";
    }
    if (variant.options["products-hero-offer-badge-corner-rounding"] == "custom") {
      themeImageBadgeCornerRounding = "";
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
        (side) => {
          themeImageBadgeCornerRounding += `${
            _.isNil(variant.options["products-hero-offer-badge-corner-" + side]) == false
              ? variant.options["products-hero-offer-badge-corner-" + side]
              : "4"
          }px `;
        }
      );
    }

    let imageBadgeFontFamily = element.options["products-image-badge-font-family"] || variant.options["products-hero-offer-badge-font-family"];
    let imageBadgeFontWeight = element.options["products-image-badge-font-family-weight"] || variant.options["products-hero-offer-badge-font-family-weight"];
    let imageBadgeFontSize = element.options["products-image-badge-font-size"] || variant.options["products-hero-offer-badge-font-size"];
    let imageBadgeFontColor = element.options["products-image-badge-text-color"] || variant.options["products-hero-offer-badge-text-color"];

    const quantityPickerShowLabel = element.options["products-quantity-picker-show-label"] == "true" ? true : false;
    const variantPickerShowLabel = element.options["products-variant-picker-show-label"] == "true" ? true : false;

    const quantityPickerButtonMinimumWidth = element.options["products-quantity-picker-minimum-width"]
      ? element.options["products-quantity-picker-minimum-width"]
      : undefined

    const quantityPickerFontFamily = element.options["products-quantity-picker-font-family"]
    const quantityPickerFontWeight = element.options["products-quantity-picker-font-weight"]
    const quantityPickerFontSize = element.options["products-quantity-picker-font-size"]
    const quantityPickerFontColor = element.options["products-quantity-picker-text-color"]
    const quantityPickerBackgroundColor = element.options["products-quantity-picker-background-color"]
    const quantityPickerBorderStyle = element.options["products-quantity-picker-border-style"]
    const quantityPickerBorderColor = element.options["products-quantity-picker-border-color"]
    const quantityPickerBorderHoverColor = element.options["products-quantity-picker-border-hover-color"] || variant.options["products-hero-quantity-picker-border-hover-color"]
    const quantityPickerBorderWidthLeft = element.options["products-quantity-picker-border-left"]
    const quantityPickerBorderWidthRight = element.options["products-quantity-picker-border-right"]
    const quantityPickerBorderWidthTop = element.options["products-quantity-picker-border-top"]
    const quantityPickerBorderWidthBottom = element.options["products-quantity-picker-border-bottom"]

    let pickerBorderRounding;
    if (element.options["products-quantity-picker-corner-rounding"] == "cf-not-rounded") {
      pickerBorderRounding = "0px";
    }
    if (element.options["products-quantity-picker-corner-rounding"] == "cf-slightly-rounded") {
      pickerBorderRounding = "4px";
    }
    if (element.options["products-quantity-picker-corner-rounding"] == "cf-fully-rounded") {
      pickerBorderRounding = "100px";
    }
    if (element.options["products-quantity-picker-corner-rounding"] == "custom") {
      pickerBorderRounding = "";
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
        (side) => {
          pickerBorderRounding += `${
            _.isNil(element.options["products-quantity-picker-corner-" + side]) == false
              ? element.options["products-quantity-picker-corner-" + side]
              : "4"
          }px `;
        }
      );
    }

    const variantPickerOptionsMinimumWidth = element.options["products-variant-picker-button-minimum-width"] || variant.options["products-hero-variant-picker-button-minimum-width"];
    const variantPickerFontFamily = element.options["products-variant-picker-font-family"] || variant.options["products-hero-variant-picker-font-family"];
    const variantPickerFontWeight = element.options["products-variant-picker-font-weight"] || variant.options["products-hero-variant-picker-font-weight"];
    const variantPickerFontSize = element.options["products-variant-picker-font-size"] || variant.options["products-hero-variant-picker-font-size"];
    const variantPickerFontColor = element.options["products-variant-picker-text-color"] || variant.options["products-hero-variant-picker-text-color"];
    let variantPickerFontHoverColor;
    if (element.options["products-variant-picker-text-hover-color"]) {
      variantPickerFontHoverColor = element.options["products-variant-picker-text-hover-color"];
    } else if (variant.options["products-hero-variant-picker-text-hover-color"]) {
      variantPickerFontHoverColor = variant.options["products-hero-variant-picker-text-hover-color"];
    } else if (element.options["products-variant-picker-style"] == "cf-options-buttons") {
      variantPickerFontHoverColor = "#fff";
    } else {
      variantPickerFontHoverColor = "#000";
    }
    const variantPickerBorderStyle = element.options["products-variant-picker-border-style"] || variant.options["products-hero-variant-picker-border-style"];
    const variantPickerBorderColor = element.options["products-variant-picker-border-color"] || variant.options["products-hero-variant-picker-border-color"];
    const variantPickerBorderHoverColor = element.options["products-variant-picker-border-hover-color"] || variant.options["products-hero-variant-picker-border-hover-color"];
    const variantPickerBorderWidthLeft = element.options["products-variant-picker-border-left"] || variant.options["products-hero-variant-picker-border-left"];
    const variantPickerBorderWidthRight = element.options["products-variant-picker-border-right"] || variant.options["products-hero-variant-picker-border-right"];
    const variantPickerBorderWidthTop = element.options["products-variant-picker-border-top"] || variant.options["products-hero-variant-picker-border-top"];
    const variantPickerBorderWidthBottom = element.options["products-variant-picker-border-bottom"] || variant.options["products-hero-variant-picker-border-bottom"];
    const variantPickerBackgroundColor = element.options["products-variant-picker-background-color"] || variant.options["products-hero-variant-picker-background-color"];
    const variantPickerBackgroundHoverColor = element.options["products-variant-picker-background-hover-color"] || variant.options["products-hero-variant-picker-background-hover-color"] || "#000";

    let variantPickerBorderRounding;
    if (element.options["products-variant-picker-corner-rounding"] == "cf-not-rounded") {
      variantPickerBorderRounding = "0px";
    }
    if (element.options["products-variant-picker-corner-rounding"] == "cf-slightly-rounded") {
      variantPickerBorderRounding = "4px";
    }
    if (element.options["products-variant-picker-corner-rounding"] == "cf-fully-rounded") {
      variantPickerBorderRounding = "100px";
    }
    if (element.options["products-variant-picker-corner-rounding"] == "custom") {
      variantPickerBorderRounding = "";
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
        (side) => {
          variantPickerBorderRounding += `${
            _.isNil(element.options["products-variant-picker-corner-" + side]) == false
              ? element.options["products-variant-picker-corner-" + side]
              : "1"
          }px `;
        }
      );
    }

    let themeVariantPickerBorderRounding;
    if (variant.options["products-hero-variant-picker-corner-rounding"] == "cf-not-rounded") {
      themeVariantPickerBorderRounding = "0px";
    }
    if (variant.options["products-hero-variant-picker-corner-rounding"] == "cf-slightly-rounded") {
      themeVariantPickerBorderRounding = "4px";
    }
    if (variant.options["products-hero-variant-picker-corner-rounding"] == "cf-fully-rounded") {
      themeVariantPickerBorderRounding = "100px";
    }
    if (variant.options["products-hero-variant-picker-corner-rounding"] == "custom") {
      themeVariantPickerBorderRounding = "";
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
        (side) => {
          themeVariantPickerBorderRounding += `${
            _.isNil(variant.options["products-hero-variant-picker-corner-" + side]) == false
              ? variant.options["products-hero-variant-picker-corner-" + side]
              : "1"
          }px `;
        }
      );
    }

    const subscriptionChoicesFontFamily = element.options["products-subscription-choices-font-family"] || variant.options["products-hero-subscription-choices-font-family"];
    const subscriptionChoicesFontWeight = element.options["products-subscription-choices-font-weight"] || variant.options["products-hero-subscription-choices-font-weight"];
    const subscriptionChoicesFontSize = element.options["products-subscription-choices-font-size"] || variant.options["products-hero-subscription-choices-font-size"];
    const subscriptionChoicesFontColor = element.options["products-subscription-choices-text-color"] || variant.options["products-hero-subscription-choices-text-color"];
    const subscriptionChoicesFontHoverColor = element.options["products-subscription-choices-text-hover-color"] || variant.options["products-hero-subscription-choices-text-hover-color"];
    const subscriptionChoicesBackgroundColor = element.options["products-subscription-choices-background-color"] || variant.options["products-hero-subscription-choices-background-color"];
    const subscriptionChoicesRadioColor = element.options["products-subscription-radio-color"] || variant.options["products-hero-subscription-radio-color"];
    const subscriptionChoicesSelectedRadioColor = element.options["products-subscription-radio-selected-color"] || variant.options["products-hero-subscription-radio-selected-color"];
    const subscriptionChoicesRadioSize = element.options["products-subscription-radio-size"] || variant.options["products-hero-subscription-radio-size"] || variant.options["products-subscription-radio-size"] || 18;

    // Radio card styling
    const radioCardBgColor = element.options["products-subscription-radio-background-color"] || variant.options["products-hero-subscription-choices-background-color"];
    const radioCardSelectedBgColor = element.options["products-subscription-radio-selected-background-color"] || variant.options["products-hero-subscription-radio-selected-background-color"];
    const radioCardHoverBgColor = element.options["products-subscription-radio-hover-background-color"] || variant.options["products-hero-subscription-radio-hover-background-color"];
    const radioCardBorderStyle = element.options["products-subscription-radio-border-style"] || variant.options["products-hero-subscription-border-style"];
    const radioCardBorderColor = element.options["products-subscription-radio-border-color"] || variant.options["products-hero-subscription-border-color"] || "#e0e0e0";
    const radioCardSelectedBorderColor = element.options["products-subscription-radio-selected-border-color"] || variant.options["products-hero-subscription-radio-selected-border-color"];
    const radioCardHoverBorderColor = element.options["products-subscription-radio-hover-border-color"] || variant.options["products-hero-subscription-border-hover-color"];
    const radioCardBorderWidthLeft = element.options["products-subscription-radio-border-left"] || variant.options["products-hero-subscription-border-left"];
    const radioCardBorderWidthRight = element.options["products-subscription-radio-border-right"] || variant.options["products-hero-subscription-border-right"];
    const radioCardBorderWidthTop = element.options["products-subscription-radio-border-top"] || variant.options["products-hero-subscription-border-top"];
    const radioCardBorderWidthBottom = element.options["products-subscription-radio-border-bottom"] || variant.options["products-hero-subscription-border-bottom"];
    const radioCardPadding = element.options["products-subscription-radio-padding"] || variant.options["products-hero-subscription-radio-padding"];
    const radioCardSpacing = element.options["products-subscription-radio-spacing"] || variant.options["products-hero-subscription-radio-spacing"];
    const effectiveRadioCardBorderWidthLeft = isValuePresent(radioCardBorderWidthLeft) ? radioCardBorderWidthLeft : "1";
    const effectiveRadioCardBorderWidthRight = isValuePresent(radioCardBorderWidthRight) ? radioCardBorderWidthRight : "1";
    const effectiveRadioCardBorderWidthTop = isValuePresent(radioCardBorderWidthTop) ? radioCardBorderWidthTop : "1";
    const effectiveRadioCardSpacing = isValuePresent(radioCardSpacing) ? Number(radioCardSpacing) : 10;
    const isStackedSubscriptionCards = effectiveRadioCardSpacing <= 0;

    const cornerRoundingSource = element.options["products-subscription-radio-corner-rounding"] || variant.options["products-hero-subscription-corner-rounding"];
    let radioCardCornerTopLeft = "0";
    let radioCardCornerTopRight = "0";
    let radioCardCornerBottomRight = "0";
    let radioCardCornerBottomLeft = "0";
    let radioCardCornerRounding;
    if (cornerRoundingSource == "cf-not-rounded") {
      radioCardCornerRounding = "0px";
      radioCardCornerTopLeft = "0";
      radioCardCornerTopRight = "0";
      radioCardCornerBottomRight = "0";
      radioCardCornerBottomLeft = "0";
    }
    if (cornerRoundingSource == "cf-slightly-rounded") {
      radioCardCornerRounding = "8px";
      radioCardCornerTopLeft = "8";
      radioCardCornerTopRight = "8";
      radioCardCornerBottomRight = "8";
      radioCardCornerBottomLeft = "8";
    }
    if (cornerRoundingSource == "cf-fully-rounded") {
      radioCardCornerRounding = "20px";
      radioCardCornerTopLeft = "20";
      radioCardCornerTopRight = "20";
      radioCardCornerBottomRight = "20";
      radioCardCornerBottomLeft = "20";
    }
    if (cornerRoundingSource == "custom") {
      radioCardCornerRounding = "";
      const customCornerValues = {};
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach((side) => {
        const val = element.options["products-subscription-radio-corner-" + side] ?? variant.options["products-hero-subscription-corner-" + side];
        customCornerValues[side] = _.isNil(val) == false ? val : "1";
        radioCardCornerRounding += `${customCornerValues[side]}px `;
      });
      radioCardCornerTopLeft = customCornerValues["top-left"];
      radioCardCornerTopRight = customCornerValues["top-right"];
      radioCardCornerBottomRight = customCornerValues["bottom-right"];
      radioCardCornerBottomLeft = customCornerValues["bottom-left"];
    }

    // Popular badge styling
    const popularBadgeBg = element.options["products-subscription-popular-badge-background"] || variant.options["products-hero-subscription-popular-badge-background"];
    const popularBadgeTextColor = element.options["products-subscription-popular-badge-text-color"] || variant.options["products-hero-subscription-popular-badge-text-color"];
    const popularBadgeFontSize = element.options["products-subscription-popular-badge-font-size"] || variant.options["products-hero-subscription-popular-badge-font-size"];
    const popularBadgeFontWeight = element.options["products-subscription-popular-badge-font-weight"] || variant.options["products-hero-subscription-popular-badge-font-weight"];

    // Description styling
    const subscriptionDescFontSize = element.options["products-subscription-description-font-size"] || variant.options["products-hero-subscription-description-font-size"];
    const subscriptionDescTextColor = element.options["products-subscription-description-text-color"] || variant.options["products-hero-subscription-description-text-color"];

    let subscriptionChoicesBorderRounding;
    if (element.options["products-subscription-corner-rounding"] == "cf-not-rounded") {
      subscriptionChoicesBorderRounding = "0px";
    }
    if (element.options["products-subscription-corner-rounding"] == "cf-slightly-rounded") {
      subscriptionChoicesBorderRounding = "4px";
    }
    if (element.options["products-subscription-corner-rounding"] == "cf-fully-rounded") {
      subscriptionChoicesBorderRounding = "100px";
    }
    if (element.options["products-subscription-corner-rounding"] == "custom") {
      subscriptionChoicesBorderRounding = "";
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
        (side) => {
          subscriptionChoicesBorderRounding += `${
            _.isNil(element.options["products-subscription-corner-" + side]) == false
              ? element.options["products-subscription-corner-" + side]
              : "1"
          }px `;
        }
      );
    }

    let variantSubscriptionChoicesBorderRounding;
    if (variant.options["products-hero-subscription-corner-rounding"] == "cf-not-rounded") {
      variantSubscriptionChoicesBorderRounding = "0px";
    }
    if (variant.options["products-hero-subscription-corner-rounding"] == "cf-slightly-rounded") {
      variantSubscriptionChoicesBorderRounding = "4px";
    }
    if (variant.options["products-hero-subscription-corner-rounding"] == "cf-fully-rounded") {
      variantSubscriptionChoicesBorderRounding = "100px";
    }
    if (variant.options["products-hero-subscription-corner-rounding"] == "custom") {
      variantSubscriptionChoicesBorderRounding = "";
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
        (side) => {
          variantSubscriptionChoicesBorderRounding += `${
            _.isNil(variant.options["products-hero-subscription-corner-" + side]) == false
              ? variant.options["products-hero-subscription-corner-" + side]
              : "1"
          }px `;
        }
      );
    }

    const subscriptionChoicesDropdownBorderStyle = element.options["products-subscription-border-style"] || variant.options["products-hero-subscription-border-style"];
    const subscriptionChoicesDropdownBorderColor = element.options["products-subscription-border-color"] || variant.options["products-hero-subscription-border-color"];
    const subscriptionChoicesDropdownBorderHoverColor = element.options["products-subscription-border-hover-color"] || variant.options["products-hero-subscription-border-hover-color"];
    const subscriptionChoicesDropdownBorderWidthLeft = element.options["products-subscription-border-left"] || variant.options["products-hero-subscription-border-left"];
    const subscriptionChoicesDropdownBorderWidthRight = element.options["products-subscription-border-right"] || variant.options["products-hero-subscription-border-right"];
    const subscriptionChoicesDropdownBorderWidthTop = element.options["products-subscription-border-top"] || variant.options["products-hero-subscription-border-top"];
    const subscriptionChoicesDropdownBorderWidthBottom = element.options["products-subscription-border-bottom"] || variant.options["products-hero-subscription-border-bottom"];
    const subscriptionChoicesShowLabel = element.options["products-subscription-show-label"] == "false" ? false : true;

    const contentTypeSpacing = element.options["products-content-type-spacing"];
    const productImageCarouselHeight = element.options["products-carousel-image-height"];

    let addAllButtonBorderRadius = "";
    if (options["products-add-all-btn-radius"] == "cf-not-rounded") {
      addAllButtonBorderRadius = "0px";
    }
    if (options["products-add-all-btn-radius"] == "cf-slightly-rounded") {
      addAllButtonBorderRadius = "4px";
    }
    if (options["products-add-all-btn-radius"] == "cf-fully-rounded") {
      addAllButtonBorderRadius = "100px";
    }
    if (options["products-add-all-btn-radius"] == "custom") {
      addAllButtonBorderRadius = "";
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
        (side) => {
          addAllButtonBorderRadius += `${
            _.isNil(options["products-add-all-btn-radius-" + side]) == false
              ? options["products-add-all-btn-radius-" + side]
              : "4"
          }px `;
        }
      );
    }

    let addAllButtonShadow;
    let addAllButtonShadowHover;

    if (options["products-add-all-btn-shadow"] == "None") {
      addAllButtonShadow = "none";
    }

    if (options["products-add-all-btn-shadow"] == "soft") {
      addAllButtonShadow = "0 5px 15px 0 rgb(179 179 179 / 78%)";
    }

    if (options["products-add-all-btn-shadow"] == "hard") {
      addAllButtonShadow = "-5px 5px 0 0 rgb(0 0 0 / 10%)";
    }

    if (options["products-add-all-btn-shadow"] == "custom") {
      addAllButtonShadow = "";
      addAllButtonShadow +=
        (options["products-add-all-btn-shadow-horizontal-distance"]
          ? `${options["products-add-all-btn-shadow-horizontal-distance"]}px`
          : "0px") + " ";

      addAllButtonShadow +=
        (options["products-add-all-btn-shadow-vertical-distance"]
          ? `${options["products-add-all-btn-shadow-vertical-distance"]}px`
          : "0px") + " ";

      addAllButtonShadow +=
        (options["products-add-all-btn-shadow-blur-radius"]
          ? `${options["products-add-all-btn-shadow-blur-radius"]}px`
          : "0px") + " ";

      addAllButtonShadow +=
        (options["products-add-all-btn-shadow-spread-radius"]
          ? `${options["products-add-all-btn-shadow-spread-radius"]}px`
          : "0px") + " ";

      addAllButtonShadow +=
        (options["products-add-all-btn-shadow-color"]
          ? options["products-add-all-btn-shadow-color"]
          : "rgba(0,0,0, 0.35)") + " ";

      addAllButtonShadowHover =
        addAllButtonShadow +
        (options["button-hover-shadow-color"]
          ? options["button-hover-shadow-color"]
          : options["products-add-all-btn-shadow-color"]
          ? options["products-add-all-btn-shadow-color"]
          : "rgba(0,0,0, 0.35)");

      addAllButtonShadow += options["products-add-all-btn-shadow-inset"] == "true" ? "inset" : "";
      addAllButtonShadowHover +=
        options["products-add-all-btn-shadow-inset"] == "true" ? "inset" : "";
    }

    const reviewsShowCount = element.options["products-reviews-show-count"] !== "false";
    const reviewsShowLabel = element.options["products-reviews-show-label"] !== "false";
    const reviewsStarColor = element.options["products-reviews-star-color"];
    const reviewsStarSize = element.options["products-reviews-star-size"];
    const reviewsFontFamily = element.options["products-reviews-font-family"];
    const reviewsFontWeight = element.options["products-reviews-font-weight"];
    const reviewsFontSize = element.options["products-reviews-font-size"];
    const reviewsFontColor = element.options["products-reviews-text-color"];

    const productsContentLabelFontSize = options["products-content-label-font-size"];
    const productsContentLabelFontWeight = options["products-content-label-font-weight"];
    const productsContentLabelFontFamily = options["products-content-label-font-family"];
    const productsContentLabelLineHeight = options["products-content-label-line-height"];
    const productsContentLabelFontColor = options["products-content-label-font-color"];

    const productsItemPriceColor = options["products-item-price-color"] || variant.options["products-hero-item-price-color"] || "#000";
    const productsItemDiscountColor = options["products-item-discount-color"] || variant.options["products-hero-item-discount-color"];

    let productButtonWidth;
    if (options["button-width"] == "cf-button-slim") {
      productButtonWidth = "min-width: fit-content !important;"
    } else if (options["button-width"] == "cf-button-mid") {
      productButtonWidth = "min-width: 150px !important;"
    } else if (options["button-width"] == "cf-full-width") {
      productButtonWidth = "min-width: 100% !important;"
    } else if (options["button-width"] == "custom") {
      productButtonWidth = "min-width: " + options["button-width-value"] + "px !important;"
    }

    let productsOuterAlignment;
    if (options["cf-alignment"] == "cf-left") {
      productsOuterAlignment = "justify-content: flex-start !important; margin-right: auto !important; margin-left: unset !important;"
    } else if (options["cf-alignment"] == "cf-center") {
      productsOuterAlignment = "justify-content: center !important; margin-left: auto !important; margin-right: auto !important;"
    } else if (options["cf-alignment"] == "cf-right") {
      productsOuterAlignment = "justify-content: flex-end !important; margin-left: auto !important; margin-right: unset !important;"
    }

    let productsInnerAlignment;
    if (options["cf-inner-alignment"] == "cf-left") {
      productsInnerAlignment = "justify-content: flex-start !important; text-align: left !important;"
    } else if (options["cf-inner-alignment"] == "cf-center") {
      productsInnerAlignment = "justify-content: center !important; text-align: center !important;"
    } else if (options["cf-inner-alignment"] == "cf-right") {
      productsInnerAlignment = "justify-content: flex-end !important; text-align: right !important;"
    }

    // prettier-ignore
    let desktopStyles =
      `#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-prod-hero-image-box {
        ${element.options["image-show"] !== "false" ? "flex-grow: 1; flex-basis: 50%;" : "display: none;"}
        ${productLayout == "cf-left" ? "justify-content: start !important;" : "justify-content: end !important;"}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-products-subscription-radio-wrapper {
        ${options["cf-inner-alignment"] == "center" ? "margin-left: auto; margin-right: auto;" : ""}
        ${options["cf-inner-alignment"] == "right" ? "margin-left: auto;" : ""}
        ${options["cf-inner-alignment"] == "left" ? "margin-right: auto;" : ""}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-products-outer {
        display: flex;
        ${productsOuterAlignment ? productsOuterAlignment : ""}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-products-item-title,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-products-item-description,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-prod-hero-content-box,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-products-options-wrapper,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quantity-picker-label,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-variant-picker-label,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-products-subscription-label,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-content-type {
        ${productsInnerAlignment ? productsInnerAlignment : ""}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-quantity-picker-label,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-variant-picker-label,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-subscription-label {
        ${productsContentLabelFontSize ? `font-size: ${productsContentLabelFontSize}px !important;` : ""}
        ${productsContentLabelFontWeight ? `font-weight: ${productsContentLabelFontWeight} !important;` : ""}
        ${productsContentLabelFontFamily ? `font-family: ${productsContentLabelFontFamily} !important;` : ""}
        ${productsContentLabelLineHeight ? `line-height: ${productsContentLabelLineHeight}px !important;` : ""}
        ${productsContentLabelFontColor ? `color: ${productsContentLabelFontColor} !important;` : ""}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element div.cf-variant-picker-wrapper select {
        ${variantPickerBorderColor ? `border-color: ${variantPickerBorderColor} !important;` : ""}
        ${variantPickerFontFamily ? `font-family: ${variantPickerFontFamily} !important;` : ''}
        ${variantPickerFontWeight ? `font-weight: ${variantPickerFontWeight} !important;` : ""}
        ${variantPickerFontSize ? `font-size: ${variantPickerFontSize}px !important;` : ""}
        ${variantPickerBorderStyle ? `border-style: ${variantPickerBorderStyle} !important;` : ""}
        ${variantPickerBorderColor ? `border-color: ${variantPickerBorderColor} !important;` : ""}
        ${variantPickerBackgroundColor ? `background: ${variantPickerBackgroundColor} !important; ${variantPickerFontColor ? `color: ${variantPickerFontColor} !important;` : ""}` : ""}
        ${variantPickerBorderWidthLeft ? `border-left-width: ${variantPickerBorderWidthLeft}px !important;` : ""}
        ${variantPickerBorderWidthRight ? `border-right-width: ${variantPickerBorderWidthRight}px !important;` : ""}
        ${variantPickerBorderWidthTop ? `border-top-width: ${variantPickerBorderWidthTop}px !important;` : ""}
        ${variantPickerBorderWidthBottom ? `border-bottom-width: ${variantPickerBorderWidthBottom}px !important;` : ""}
        ${variantPickerBorderRounding ? `border-radius: ${variantPickerBorderRounding} !important;` : themeVariantPickerBorderRounding ? `border-radius: ${themeVariantPickerBorderRounding} !important;` : ""}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element div.cf-products-subscription-dropdown-wrapper select {
        ${subscriptionChoicesBackgroundColor ? `background: ${subscriptionChoicesBackgroundColor} !important;` : ""}
        ${subscriptionChoicesDropdownBorderStyle ? `border-style: ${subscriptionChoicesDropdownBorderStyle} !important;` : ""}
        ${subscriptionChoicesDropdownBorderColor ? `border-color: ${subscriptionChoicesDropdownBorderColor} !important;` : ""}
        ${isValuePresent(subscriptionChoicesDropdownBorderWidthLeft) == true ? `border-left-width: ${subscriptionChoicesDropdownBorderWidthLeft}px !important;` : ""}
        ${isValuePresent(subscriptionChoicesDropdownBorderWidthRight) == true ? `border-right-width: ${subscriptionChoicesDropdownBorderWidthRight}px !important;` : ""}
        ${isValuePresent(subscriptionChoicesDropdownBorderWidthTop) == true ? `border-top-width: ${subscriptionChoicesDropdownBorderWidthTop}px !important;` : ""}
        ${isValuePresent(subscriptionChoicesDropdownBorderWidthBottom) == true ? `border-bottom-width: ${subscriptionChoicesDropdownBorderWidthBottom}px !important;` : ""}
        ${isValuePresent(subscriptionChoicesBorderRounding) == true ? `border-radius: ${subscriptionChoicesBorderRounding} !important;` : isValuePresent(variantSubscriptionChoicesBorderRounding) == true ? `border-radius: ${variantSubscriptionChoicesBorderRounding} !important;` : ""}
        ${subscriptionChoicesDropdownBorderHoverColor ? `&:hover { border-color: ${subscriptionChoicesDropdownBorderHoverColor} !important; }` : ""}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-reviews-count {
        display: ${reviewsShowCount ? "block" : "none"};
        ${reviewsFontFamily ? `font-family: ${reviewsFontFamily} !important;` : ""}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-reviews-label {
        display: ${reviewsShowLabel ? "block" : "none"};
        ${reviewsFontFamily ? `font-family: ${reviewsFontFamily} !important;` : ""}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-reviews {
        ${reviewsFontWeight ? `font-weight: ${reviewsFontWeight} !important;` : ""}
        ${reviewsFontSize ? `font-size: ${reviewsFontSize}px !important;` : ""}
        ${reviewsFontColor ? `color: ${reviewsFontColor} !important;` : ""}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-reviews-stars-inner svg {
        ${reviewsStarColor ? `color: ${reviewsStarColor};` : ""}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-reviews-stars-inner .svg-inline--fa {
        ${reviewsStarSize ? `font-size: ${reviewsStarSize}px;` : ""}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-quantity-picker-label {
        display: ${quantityPickerShowLabel ? "block" : "none"};
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-product__image {
        ${productImageCarouselHeight ? `height: ${productImageCarouselHeight}px;` : ""}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-variant-picker-label {
        display: ${variantPickerShowLabel ? "block" : "none"};
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-subscription-label {
        display: ${subscriptionChoicesShowLabel ? "block" : "none"} !important;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-product-content-type {
        ${contentTypeSpacing ? `margin-bottom: ${contentTypeSpacing}px !important;` : ""}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-product-content-type.cf-product-custom-element,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-product-content-type.cf-product-custom-element > .cf-section,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-product-content-type.cf-product-custom-element > .cf-section > .cf-section-container {
        width: 100% !important;
        min-width: 100% !important;
        max-width: 100% !important;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-product-content-type.cf-product-custom-element > .cf-section > .cf-section-container {
        display: flex !important;
        flex-wrap: wrap !important;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element div.cf-products-subscription-dropdown-wrapper select,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-subscription-radio-wrapper label,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-subscription-plan-price-column {
        ${subscriptionChoicesFontFamily ? `font-family: ${subscriptionChoicesFontFamily} !important;` : ""}
        ${subscriptionChoicesFontWeight ? `font-weight: ${subscriptionChoicesFontWeight} !important;` : ""}
        ${subscriptionChoicesFontSize ? `font-size: ${subscriptionChoicesFontSize}px !important;` : ""}
        ${subscriptionChoicesFontColor ? `color: ${subscriptionChoicesFontColor} !important;` : ""}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element div.cf-products-subscription-dropdown-wrapper select {
        ${subscriptionChoicesFontHoverColor ? `&:hover { color: ${subscriptionChoicesFontHoverColor} !important; }` : ""}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-subscription-radio-wrapper > p > label {
        text-align: left;
        line-height: 1.4;
        padding-top: 2px;
        ${subscriptionChoicesFontHoverColor ? `&:hover { color: ${subscriptionChoicesFontHoverColor} !important; }` : ""}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-subscription-radio-wrapper .cf-subscription-radio-card label {
        flex: 1;
        text-align: left;
        width: 100%;
        line-height: 1.4;
        padding-top: 2px;
        ${subscriptionChoicesFontHoverColor ? `&:hover { color: ${subscriptionChoicesFontHoverColor} !important; }` : ""}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element div.cf-products-subscription-dropdown-wrapper select {
        ${subscriptionChoicesBackgroundColor ? `background: ${subscriptionChoicesBackgroundColor} !important;` : ""}
        ${subscriptionChoicesDropdownBorderStyle ? `border-style: ${subscriptionChoicesDropdownBorderStyle} !important;` : ""}
        ${subscriptionChoicesDropdownBorderColor ? `border-color: ${subscriptionChoicesDropdownBorderColor} !important;` : ""}
        ${subscriptionChoicesDropdownBorderWidthLeft ? `border-left-width: ${subscriptionChoicesDropdownBorderWidthLeft}px !important;` : ""}
        ${subscriptionChoicesDropdownBorderWidthRight ? `border-right-width: ${subscriptionChoicesDropdownBorderWidthRight}px !important;` : ""}
        ${subscriptionChoicesDropdownBorderWidthTop ? `border-top-width: ${subscriptionChoicesDropdownBorderWidthTop}px !important;` : ""}
        ${subscriptionChoicesDropdownBorderWidthBottom ? `border-bottom-width: ${subscriptionChoicesDropdownBorderWidthBottom}px !important;` : ""}
        ${subscriptionChoicesBorderRounding ? `border-radius: ${subscriptionChoicesBorderRounding} !important;` : ""}
        ${subscriptionChoicesDropdownBorderHoverColor ? `&:hover { border-color: ${subscriptionChoicesDropdownBorderHoverColor} !important; }` : ""}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-subscription-radio-wrapper > p input[type="radio"] {
        appearance: none !important;
        -webkit-appearance: none !important;
        width: ${subscriptionChoicesRadioSize}px !important;
        height: ${subscriptionChoicesRadioSize}px !important;
        min-width: ${subscriptionChoicesRadioSize}px !important;
        border-radius: 999px !important;
        border: 2px solid ${subscriptionChoicesRadioColor || "#D4DDEA"} !important;
        background: ${subscriptionChoicesRadioColor || "#D4DDEA"} !important;
        margin: 2px 10px 0 0 !important;
        padding: 0 !important;
        flex-shrink: 0 !important;
        display: inline-block !important;
        vertical-align: top !important;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-subscription-radio-wrapper > p input[type="radio"]:checked {
        border-color: ${subscriptionChoicesSelectedRadioColor || "#003FFF"} !important;
        background: ${subscriptionChoicesSelectedRadioColor || "#003FFF"} !important;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-subscription-radio-wrapper > p input[type="radio"]:focus-visible {
        outline: 2px solid ${subscriptionChoicesSelectedRadioColor || "#003FFF"} !important;
        outline-offset: 2px !important;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-subscription-radio-wrapper .cf-subscription-radio-card input[type="radio"] {
        appearance: none !important;
        -webkit-appearance: none !important;
        width: ${subscriptionChoicesRadioSize}px !important;
        height: ${subscriptionChoicesRadioSize}px !important;
        min-width: ${subscriptionChoicesRadioSize}px !important;
        border-radius: 999px !important;
        border: 2px solid ${subscriptionChoicesRadioColor || "#D4DDEA"} !important;
        background: #fff !important;
        margin: 2px 10px 0 0 !important;
        padding: 0 !important;
        flex-shrink: 0 !important;
        display: inline-block !important;
        vertical-align: top !important;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-subscription-radio-wrapper .cf-subscription-radio-card input[type="radio"]:checked {
        border-color: ${subscriptionChoicesSelectedRadioColor || "#003FFF"} !important;
        background: radial-gradient(circle, ${subscriptionChoicesSelectedRadioColor || "#003FFF"} 0 45%, transparent 46%) !important;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-subscription-radio-wrapper .cf-subscription-radio-card input[type="radio"]:focus-visible {
        outline: 2px solid ${subscriptionChoicesSelectedRadioColor || "#003FFF"} !important;
        outline-offset: 2px !important;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-subscription-radio-card {
        border-style: ${radioCardBorderStyle || "solid"} !important;
        border-color: ${radioCardBorderColor} !important;
        ${radioCardBgColor ? `background: ${radioCardBgColor} !important;` : ""}
        padding: ${radioCardPadding || "15"}px !important;
        margin-bottom: ${isStackedSubscriptionCards ? "0" : effectiveRadioCardSpacing}px !important;
        border-left-width: ${effectiveRadioCardBorderWidthLeft}px !important;
        border-right-width: ${effectiveRadioCardBorderWidthRight}px !important;
        border-top-width: ${effectiveRadioCardBorderWidthTop}px !important;
        border-bottom-width: ${isValuePresent(radioCardBorderWidthBottom) ? radioCardBorderWidthBottom : "1"}px !important;
        ${radioCardCornerRounding ? `border-radius: ${radioCardCornerRounding} !important;` : ""}
        cursor: pointer;
        overflow: hidden;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-subscription-radio-card:hover {
        ${radioCardHoverBorderColor ? `border-color: ${radioCardHoverBorderColor} !important;` : ""}
        ${radioCardHoverBgColor ? `background: ${radioCardHoverBgColor} !important;` : ""}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-subscription-radio-card:has(input[type="radio"]:checked),
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-subscription-radio-card.cf-subscription-selected {
        ${radioCardSelectedBorderColor ? `border-color: ${radioCardSelectedBorderColor} !important;` : ""}
        ${radioCardSelectedBgColor ? `background: ${radioCardSelectedBgColor} !important;` : ""}
      }

      ${isStackedSubscriptionCards ? `
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-subscription-radio-wrapper .cf-subscription-radio-card {
        border-bottom-width: 0 !important;
        border-radius: 0 !important;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-subscription-radio-wrapper .cf-subscription-radio-card:first-child {
        border-top-left-radius: ${radioCardCornerTopLeft}px !important;
        border-top-right-radius: ${radioCardCornerTopRight}px !important;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-subscription-radio-wrapper .cf-subscription-radio-card:last-child {
        border-bottom-width: ${isValuePresent(radioCardBorderWidthBottom) ? radioCardBorderWidthBottom : "1"}px !important;
        border-bottom-left-radius: ${radioCardCornerBottomLeft}px !important;
        border-bottom-right-radius: ${radioCardCornerBottomRight}px !important;
      }
      ` : ""}

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-subscription-radio-card-inner > p,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-subscription-radio-card-inner .cf-subscription-radio-row {
        margin: 0 !important;
        display: flex !important;
        align-items: flex-start !important;
        gap: 10px !important;
        padding-top: 2px !important;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-subscription-popular-badge {
        text-align: center;
        ${popularBadgeBg ? `background: ${popularBadgeBg} !important;` : "background: #000 !important;"}
        ${popularBadgeTextColor ? `color: ${popularBadgeTextColor} !important;` : "color: #fff !important;"}
        ${popularBadgeFontSize ? `font-size: ${popularBadgeFontSize}px !important;` : "font-size: 12px !important;"}
        ${popularBadgeFontWeight ? `font-weight: ${popularBadgeFontWeight} !important;` : "font-weight: bold !important;"}
        padding: 6px 12px;
        margin-top: calc(-${radioCardPadding || "15"}px - ${effectiveRadioCardBorderWidthTop}px) !important;
        margin-right: calc(-${radioCardPadding || "15"}px - ${effectiveRadioCardBorderWidthRight}px) !important;
        margin-bottom: ${radioCardPadding || "15"}px !important;
        margin-left: calc(-${radioCardPadding || "15"}px - ${effectiveRadioCardBorderWidthLeft}px) !important;
        border-top-left-radius: ${radioCardCornerTopLeft}px !important;
        border-top-right-radius: ${radioCardCornerTopRight}px !important;
        letter-spacing: 1px;
        text-transform: uppercase;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-subscription-radio-description {
        ${subscriptionDescFontSize ? `font-size: ${subscriptionDescFontSize}px !important;` : ""}
        ${subscriptionDescTextColor ? `color: ${subscriptionDescTextColor} !important;` : ""}
        margin-top: 8px;
        text-align: left !important;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-subscription-radio-description div,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-subscription-radio-description p,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-subscription-radio-description h1,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-subscription-radio-description h2,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-subscription-radio-description h3,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-subscription-radio-description ul,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-subscription-radio-description li {
        text-align: left !important;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element div.cf-variant-picker-wrapper.cf-product-content-type > div > select {
        ${variantPickerBorderColor ? `border-color: ${variantPickerBorderColor} !important;` : ""}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element div.cf-variant-picker-wrapper.cf-product-content-type > div > select {
        ${variantPickerFontFamily ? `font-family: ${variantPickerFontFamily} !important;` : ''}
        ${variantPickerFontWeight ? `font-weight: ${variantPickerFontWeight} !important;` : ""}
        ${variantPickerFontSize ? `font-size: ${variantPickerFontSize}px !important;` : ""}
        ${variantPickerBorderStyle ? `border-style: ${variantPickerBorderStyle} !important;` : ""}
        ${variantPickerBorderColor ? `border-color: ${variantPickerBorderColor} !important;` : ""}
        ${variantPickerBackgroundColor ? `background: ${variantPickerBackgroundColor} !important; ${variantPickerFontColor ? `color: ${variantPickerFontColor} !important;` : ""}` : ""}
        ${variantPickerBorderWidthLeft ? `border-left-width: ${variantPickerBorderWidthLeft}px !important;` : ""}
        ${variantPickerBorderWidthRight ? `border-right-width: ${variantPickerBorderWidthRight}px !important;` : ""}
        ${variantPickerBorderWidthTop ? `border-top-width: ${variantPickerBorderWidthTop}px !important;` : ""}
        ${variantPickerBorderWidthBottom ? `border-bottom-width: ${variantPickerBorderWidthBottom}px !important;` : ""}
        ${variantPickerBorderRounding ? `border-radius: ${variantPickerBorderRounding} !important;` : themeVariantPickerBorderRounding ? `border-radius: ${themeVariantPickerBorderRounding} !important;` : ""}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-option-item {
        ${variantPickerOptionsMinimumWidth ? `min-width: ${variantPickerOptionsMinimumWidth}px !important;` : ""}
        ${variantPickerFontFamily ? `font-family: ${variantPickerFontFamily} !important;` : ""}
        ${variantPickerFontWeight ? `font-weight: ${variantPickerFontWeight} !important;` : ""}
        ${variantPickerFontSize ? `font-size: ${variantPickerFontSize}px !important;` : ""}
        ${variantPickerFontColor ? `color: ${variantPickerFontColor} !important;` : ""}
        ${variantPickerBorderStyle ? `border-style: ${variantPickerBorderStyle} !important;` : ""}
        ${variantPickerBorderColor ? `border-color: ${variantPickerBorderColor} !important;` : ""}
        ${variantPickerBackgroundColor ? `background: ${variantPickerBackgroundColor} !important;` : ""}
        ${variantPickerBorderWidthLeft ? `border-left-width: ${variantPickerBorderWidthLeft}px !important;` : ""}
        ${variantPickerBorderWidthRight ? `border-right-width: ${variantPickerBorderWidthRight}px !important;` : ""}
        ${variantPickerBorderWidthTop ? `border-top-width: ${variantPickerBorderWidthTop}px !important;` : ""}
        ${variantPickerBorderWidthBottom ? `border-bottom-width: ${variantPickerBorderWidthBottom}px !important;` : ""}
        ${variantPickerBorderRounding ? `border-radius: ${variantPickerBorderRounding} !important;` : themeVariantPickerBorderRounding ? `border-radius: ${themeVariantPickerBorderRounding} !important;` : ""}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element div.cf-variant-picker-wrapper select:hover,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element div.cf-variant-picker-wrapper.cf-product-content-type > div > select:hover {
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-option-item:hover {
        ${variantPickerFontHoverColor ? `color: ${variantPickerFontHoverColor} !important;` : "color: #fff;"}
        ${variantPickerBorderHoverColor ? `border-color: ${variantPickerBorderHoverColor} !important;` : "border-color: #000;"}
        ${variantPickerBackgroundHoverColor ? `background: ${variantPickerBackgroundHoverColor} !important;` : "background: #000;"}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-item-button--selected {
        ${variantPickerFontHoverColor ? `color: ${variantPickerFontHoverColor} !important;` : "color: #fff;"}
        ${variantPickerBorderHoverColor ? `border-color: ${variantPickerBorderHoverColor} !important;` : ""}
        ${variantPickerBackgroundHoverColor ? `background: ${variantPickerBackgroundHoverColor} !important;` : "background: #000;"}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-quantity-picker-wrapper {
        ${quantityPickerButtonMinimumWidth ? `width: ${quantityPickerButtonMinimumWidth}px !important;` : ""}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-increment-quantity-picker {
        ${quantityPickerFontWeight ? `font-weight: ${quantityPickerFontWeight} !important;` : ""}
        ${quantityPickerFontSize ? `font-size: ${quantityPickerFontSize}px !important;` : ""}
        ${quantityPickerFontColor ? `color: ${quantityPickerFontColor} !important;` : ""}
        ${quantityPickerBackgroundColor ? `background: ${quantityPickerBackgroundColor} !important;` : ""}
        ${quantityPickerBorderStyle ? `border-style: ${quantityPickerBorderStyle} !important;` : ""}
        ${quantityPickerBorderColor ? `border-color: ${quantityPickerBorderColor};` : ""}
        ${quantityPickerBorderWidthLeft ? `border-left-width: ${quantityPickerBorderWidthLeft}px !important;` : ""}
        ${quantityPickerBorderWidthRight ? `border-right-width: ${quantityPickerBorderWidthRight}px !important;` : ""}
        ${quantityPickerBorderWidthBottom ? `border-bottom-width: ${quantityPickerBorderWidthBottom}px !important;` : ""}
        ${quantityPickerBorderWidthTop ? `border-top-width: ${quantityPickerBorderWidthTop}px !important;` : ""}
        ${pickerBorderRounding ? `border-radius: ${pickerBorderRounding} !important;` : ""}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-increment-quantity-picker {
        ${quantityPickerBorderColor ? `border-color: ${quantityPickerBorderColor} !important;` : "border-color: #000;"}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-increment-quantity-picker .cf-decrement,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-increment-quantity-picker .cf-products-quantity,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-increment-quantity-picker .cf-increment {
        ${quantityPickerFontFamily ? `font-family: ${quantityPickerFontFamily} !important;` : ""}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-increment-quantity-picker:hover {
        ${quantityPickerBorderHoverColor ? `border-color: ${quantityPickerBorderHoverColor} !important;` : ""}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-prod-hero-content-box {
        ${options["products-item-content-width"] ? 'width: ' + options["products-item-content-width"] + 'px !important;' : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-prod-hero-image-box {
        ${options["products-item-image-max-width"] ? 'max-width: ' + options["products-item-image-max-width"] + 'px !important;' : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-item {
        ${outerPadding ? 'padding: ' + outerPadding + ' !important;' : ''}
        ${verticalMargin ? 'margin-bottom: ' + verticalMargin + ' !important;' : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-product-hero-inner {
        display: flex !important;
        max-width: 100% !important;
        max-width: -webkit-fill-available !important;
        max-width: fill-available !important;
        ${options["products-item-width"] ? 'width: ' + options["products-item-width"] + 'px !important;' : ''}
        ${productLayout == "cf-left" ? "flex-direction: row-reverse;" : "flex-direction: row;"}
        ${innerPadding ? 'padding: ' + innerPadding + ' !important;' : ''}
        ${options["products-horizontal-spacing"] ? 'gap: ' + options["products-horizontal-spacing"] + 'px !important;' : ''}
        ${options["products-item-background-color"] ? 'background: ' + options["products-item-background-color"] + ' !important;' : ''}
        ${options["products-item-border-style"] ? 'border-style: ' + options["products-item-border-style"] + '!important;' : ''}
        ${_.isNil(options["products-item-border-width"]) == false ? 'border-width: ' + options["products-item-border-width"] + 'px !important;' : ''}
        ${_.isNil(options["products-item-border-width-left"]) == false ? 'border-left-width: ' + options["products-item-border-width-left"] + 'px !important;' : ''}
        ${_.isNil(options["products-item-border-width-right"]) == false ? 'border-right-width: ' + options["products-item-border-width-right"] + 'px !important;' : ''}
        ${_.isNil(options["products-item-border-width-bottom"]) == false ? 'border-bottom-width: ' + options["products-item-border-width-bottom"] + 'px !important;' : ''}
        ${_.isNil(options["products-item-border-width-top"]) == false ? 'border-top-width: ' + options["products-item-border-width-top"] + 'px !important;' : ''}
        ${options["products-item-border-color"] ? 'border-color: ' + options["products-item-border-color"] + ' !important;' : ''}
        ${borderRadius ? 'border-radius: ' + borderRadius + ' !important;' : ''}
        ${boxShadow ? 'box-shadow: ' + boxShadow + ' !important;' : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-item-image img, #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-item-image svg {
        ${options["products-item-image-height"] ? 'height: ' + options["products-item-image-height"] + 'px !important;' : ''}
        ${imageBorderRadius ? 'border-radius: ' + imageBorderRadius + ' !important;' : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-item-badge {
        ${imageBadgePosition ? imageBadgePosition : ""}
        ${imageBadgeBackground ? `background: ${imageBadgeBackground} !important;` : ""}
        ${imageBadgeCornerRounding ? `border-radius: ${imageBadgeCornerRounding} !important;` : themeImageBadgeCornerRounding ? `border-radius: ${themeImageBadgeCornerRounding} !important;` : ""}
        ${imageBadgeFontFamily ? `font-family: ${imageBadgeFontFamily}, Helvetica, Arial, sans-serif !important;` : 'font-family: "Inter", Helvetica, sans-serif;'}
        ${imageBadgeFontWeight ? `font-weight: ${imageBadgeFontWeight} !important;` : ''}
        ${imageBadgeFontSize ? `font-size: ${imageBadgeFontSize}px !important;` : ''}
        ${imageBadgeFontColor ? `color: ${imageBadgeFontColor} !important;` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-item-title p {
        ${options["products-item-title-size"] ? 'font-size: ' + options["products-item-title-size"] + 'px !important;' : ''}
        ${options["products-item-title-line-height"] ? 'line-height: ' + options["products-item-title-line-height"] + 'px !important;' : ''}
        ${options["products-item-title-font"] ? 'font-family: ' + options["products-item-title-font"] + ', Helvetica, Arial, sans-serif !important;' : ''}
        ${options['products-item-title-font-weight'] ? 'font-weight: ' + options['products-item-title-font-weight'] + ' !important;' : ''}
        ${options["products-item-title-color"] ? 'color: ' + options["products-item-title-color"] + ' !important;' : ''}
        ${options["products-title-max-number-of-lines"] ? `-webkit-line-clamp: ${options["products-title-max-number-of-lines"]}; display: -webkit-box !important;` : ''}
        ${options["products-title-max-number-of-lines"] ? `line-clamp: ${options["products-title-max-number-of-lines"]};` : ''}
        ${options["products-title-max-number-of-lines"] ? `white-space: normal !important;` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-item-price p {
        line-height: unset !important;
        ${options["products-item-price-size"] ? 'font-size: ' + options["products-item-price-size"] + 'px !important;' : ''}
        ${options["products-item-price-font"] ? 'font-family: ' + options["products-item-price-font"] + ', Helvetica, Arial, sans-serif !important;' : ''}
        ${options['products-item-price-font-weight'] ? 'font-weight: ' + options['products-item-price-font-weight'] + ' !important;' : ''}
        ${productsItemPriceColor ? `color: ${productsItemPriceColor} !important;`: ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-item-price[data-discount="true"] p {
        ${productsItemDiscountColor ? `color: ${productsItemDiscountColor} !important; opacity: 1'`: ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-item-price[data-discount="true"] p strike {
        ${productsItemPriceColor ? `color: ${productsItemPriceColor} !important;`: ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-item-description {
        ${options["products-description-max-number-of-lines"] ? `-webkit-line-clamp: ${options["products-description-max-number-of-lines"]};` : ''}
        ${options["products-description-max-number-of-lines"] ? `line-clamp: ${options["products-description-max-number-of-lines"]}; display: -webkit-box !important;` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-item-description,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-item-description p,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-item-description h1,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-item-description h2,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-item-description h3,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-item-description h4,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-empty-message p {
        ${options["products-item-description-size"] ? 'font-size: ' + options["products-item-description-size"] + 'px !important;' : ''}
        ${options["products-item-description-font"] ? 'font-family: ' + options["products-item-description-font"] + ', Helvetica, Arial, sans-serif !important;' : ''}
        ${options['products-item-description-font-weight'] ? 'font-weight: ' + options['products-item-description-font-weight'] + ' !important;' : ''}
        ${options["products-item-description-color"] ? 'color: ' + options["products-item-description-color"] + ' !important;' : ''}
        ${options["products-item-description-line-height"] ? `line-height: ${options["products-item-description-line-height"]}px !important;` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-product-hero-outer-button {
        ${options["button-width"] == "cf-full-width" ? "width: 100% !important;" : "width: auto !important;"}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-button {
        ${options["button-color"] ? 'background: ' + options["button-color"] + '!important;' : ''}
        ${options["button-text-color"] ? 'color: ' + options["button-text-color"] + ' !important;' : ''}
        ${productButtonWidth ? productButtonWidth : ""}
        ${options["button-size"] == 'custom' && options["button-size-value"] ? 'padding: ' + options["button-size-value"] + 'px 20px !important;' : ''}
        ${options["button-border-style"] ? 'border-style: ' + options["button-border-style"] + ' !important;' : ''}
        ${options["button-border-style"] !== "" && _.isNil(options["button-border-width"]) == false ? 'border-width: ' + options["button-border-width"] + 'px !important;' : ''}
        ${options["button-border-style"] !== "" && _.isNil(options["button-border-width-left"]) == false ? 'border-left-width: ' + options["button-border-width-left"] + 'px !important;' : _.isNil(options["button-border-width"]) == false ? 'border-left-width: ' + options["button-border-width"] + 'px !important;' : ''}
        ${options["button-border-style"] !== "" && _.isNil(options["button-border-width-right"]) == false ? 'border-right-width: ' + options["button-border-width-right"] + 'px !important;' : _.isNil(options["button-border-width"]) == false ? 'border-right-width: ' + options["button-border-width"] + 'px !important;' : ''}
        ${options["button-border-style"] !== "" && _.isNil(options["button-border-width-top"]) == false ? 'border-top-width: ' + options["button-border-width-top"] + 'px !important;' : _.isNil(options["button-border-width"]) == false ? 'border-top-width: ' + options["button-border-width"] + 'px !important;' : ''}
        ${options["button-border-style"] !== "" && _.isNil(options["button-border-width-bottom"]) == false ? 'border-bottom-width: ' + options["button-border-width-bottom"] + 'px !important;' : _.isNil(options["button-border-width"]) == false ? 'border-bottom-width: ' + options["button-border-width"] + 'px !important;' : ''}
        ${options["button-border-style"] !== "" && options["button-border-color"] ? 'border-color: ' + options["button-border-color"] + ' !important;' : options["button-color"] ? 'border-color: ' + options["button-color"] + ' !important;' : ''}
        ${buttonBorderRadius ? 'border-radius: ' + buttonBorderRadius + ' !important;' : ''}
        ${buttonShadow ? 'box-shadow: ' + buttonShadow + ' !important;' : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-all-button-outer .cf-button {
        ${options["products-add-all-btn-color"] ? `background: ${options["products-add-all-btn-color"]} !important;` : ""}
        ${options["products-add-all-btn-text-color"] ? `color: ${options["products-add-all-btn-text-color"]} !important;` : ""}
        ${options["products-add-all-btn-padding"] == 'custom' && options["products-add-all-btn-padding-value"] ? `padding: ${options["products-add-all-btn-padding-value"]}px 20px !important;` : ""}
        ${options["products-add-all-btn-border-style"] ? `border-style: ${options["products-add-all-btn-border-style"]} !important;` : ""}
        ${options["products-add-all-btn-border-style"] !== "" && _.isNil(options["products-add-all-btn-border-width"]) == false ? 'border-width: ' + options["products-add-all-btn-border-width"] + 'px !important;' : ''}
        ${options["products-add-all-btn-border-style"] !== "" && _.isNil(options["products-add-all-btn-border-width-left"]) == false ? 'border-left-width: ' + options["products-add-all-btn-border-width-left"] + 'px !important;' : _.isNil(options["products-add-all-btn-border-width"]) == false ? 'border-left-width: ' + options["products-add-all-btn-border-width"] + 'px !important;' : ''}
        ${options["products-add-all-btn-border-style"] !== "" && _.isNil(options["products-add-all-btn-border-width-right"]) == false ? 'border-right-width: ' + options["products-add-all-btn-border-width-right"] + 'px !important;' : _.isNil(options["products-add-all-btn-border-width"]) == false ? 'border-right-width: ' + options["products-add-all-btn-border-width"] + 'px !important;' : ''}
        ${options["products-add-all-btn-border-style"] !== "" && _.isNil(options["products-add-all-btn-border-width-top"]) == false ? 'border-top-width: ' + options["products-add-all-btn-border-width-top"] + 'px !important;' : _.isNil(options["products-add-all-btn-border-width"]) == false ? 'border-top-width: ' + options["products-add-all-btn-border-width"] + 'px !important;' : ''}
        ${options["products-add-all-btn-border-style"] !== "" && _.isNil(options["products-add-all-btn-border-width-bottom"]) == false ? 'border-bottom-width: ' + options["products-add-all-btn-border-width-bottom"] + 'px !important;' : _.isNil(options["products-add-all-btn-border-width"]) == false ? 'border-bottom-width: ' + options["products-add-all-btn-border-width"] + 'px !important;' : ''}
        ${options["products-add-all-btn-border-style"] !== "" && options["products-add-all-btn-border-color"] ? 'border-color: ' + options["products-add-all-btn-border-color"] + ' !important;' : ''}
        ${addAllButtonBorderRadius ? `border-radius: ${addAllButtonBorderRadius} !important;` : ""}
        ${addAllButtonShadow ? `box-shadow: ${addAllButtonShadow} !important;` : ""}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-button:hover, #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-button:active {
        ${options["button–hover-color"] ? 'background: ' + options["button–hover-color"] + ' !important;' : options["button-color"] ? 'background: ' + options["button-color"] + ' !important;' : ''}
        ${options["button–hover-text-color"] ? 'color: ' + options["button–hover-text-color"] + ' !important;' : options["button-text-color"] ? 'color: ' + options["button-text-color"] + ' !important;' : ''}
        ${options["button-hover-border-color"] ? 'border-color: ' + options["button-hover-border-color"] + ' !important;' : options["button-border-color"] ? 'border-color: ' +  options["button-border-color"] + ' !important;' : ''}
        ${buttonShadowHover ? 'box-shadow: ' + buttonShadowHover + ' !important;' : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-all-button-outer .cf-button:hover, #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-all-button-outer .cf-button:active {
        ${options["products-add-all-btn-hover-color"] ? `background: ${options["products-add-all-btn-hover-color"]} !important;` : ""}
        ${options["products-add-all-btn-hover-text-color"] ? `color: ${options["products-add-all-btn-hover-text-color"]} !important;` : ""}
        ${options["products-add-all-btn-hover-border-color"] ? `border-color: ${options["products-add-all-btn-hover-border-color"]} !important;` : ""}
        ${addAllButtonShadowHover ? `box-shadow: ${addAllButtonShadowHover} !important;` : ""}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-button p {
        ${buttonFont ? `font-family: ${buttonFont} !important;` : ''}
        ${buttonFontWeight ? `font-weight: ${buttonFontWeight} !important;` : ''}
        ${buttonFontSize ? `font-size: ${buttonFontSize}px !important;` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-all-button-outer .cf-button p {
        ${options["products-add-all-btn-font-family"] ? `font-family: ${options["products-add-all-btn-font-family"]} !important;` : ""}
        ${options["products-add-all-btn-font-weight"] ? `font-weight: ${options["products-add-all-btn-font-weight"]} !important;` : ""}
        ${options["products-add-all-btn-font-size"] ? `font-size: ${options["products-add-all-btn-font-size"]}px !important;` : ""}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-prod-hero-inner-box {
        max-width: 100%;
        ${element.options["image-show"] !== "false" ? "flex-grow: 1; flex-basis: 50%; overflow: hidden;" : "flex-grow: 1; flex-basis: 100%;"}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-prod-hero-inner-box:has(.cf-prod-hero-image-box) {
        position: sticky;
        top: 0;
        align-self: flex-start;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-prod-hero-content-box {
        max-width: 100% !important;
      }
      `;

    const productLayoutMobile = options["products-layout-mobile"];

    let buttonFontSizeMobile;
    if (options["button-font-size-mobile"]) {
      buttonFontSizeMobile = options["button-font-size-mobile"];
    }

    let imageBadgeFontSizeMobile = element.options["products-image-badge-font-size-mobile"] || variant.options["products-hero-offer-badge-font-size-mobile"]

    const quantityPickerButtonMinimumWidthMobile = element.options["products-quantity-picker-minimum-width-mobile"]
      ? element.options["products-quantity-picker-minimum-width-mobile"]
      : undefined

    const quantityPickerFontSizeMobile = element.options["products-quantity-picker-font-size-mobile"];
    const variantPickerOptionsMinimumWidthMobile = element.options["products-variant-picker-button-minimum-width-mobile"] || variant.options["products-hero-variant-picker-button-minimum-width-mobile"];
    const variantPickerFontSizeMobile = element.options["products-variant-picker-font-size-mobile"] || variant.options["products-hero-variant-picker-font-size-mobile"];

    const contentTypeSpacingMobile = element.options["products-content-type-spacing-mobile"];

    const productImageCarouselHeightMobile = element.options["products-carousel-image-height-mobile"];

    const subscriptionChoicesFontSizeMobile = element.options["products-subscription-choices-font-size-mobile"] || variant.options["products-hero-subscription-choices-font-size-mobile"];

    const reviewsStarSizeMobile = element.options["products-reviews-star-size-mobile"];
    const reviewsFontSizeMobile = element.options["products-reviews-font-size-mobile"];

    const productsContentLabelFontSizeMobile = options["products-content-label-font-size-mobile"];
    const productsContentLabelLineHeightMobile = options["products-content-label-line-height-mobile"];

    let productButtonWidthMobile;
    if (options["button-width-mobile"] == "cf-button-slim") {
      productButtonWidthMobile = "min-width: fit-content !important;"
    } else if (options["button-width-mobile"] == "cf-button-mid") {
      productButtonWidthMobile = "min-width: 150px !important;"
    } else if (options["button-width-mobile"] == "cf-full-width") {
      productButtonWidthMobile = "min-width: 100% !important;"
    } else if (options["button-width-mobile"] == "custom" || (!options["button-width-mobile"] && options["button-width"] == "custom")) {
      productButtonWidthMobile = `min-width: ${options["button-width-value-mobile"] || options["button-width-value"]}px !important;`
    }

    let productsOuterAlignmentMobile;
    if (options["cf-alignment-mobile"] == "cf-mobile-left") {
      productsOuterAlignmentMobile = "justify-content: flex-start !important; margin-right: auto !important; margin-left: unset !important;"
    } else if (options["cf-alignment-mobile"] == "cf-mobile-center") {
      productsOuterAlignmentMobile = "justify-content: center !important; margin-left: auto !important; margin-right: auto !important;"
    } else if (options["cf-alignment-mobile"] == "cf-mobile-right") {
      productsOuterAlignmentMobile = "justify-content: flex-end !important; margin-left: auto !important; margin-right: unset !important;"
    }

    let productsInnerAlignmentMobile;
    if (options["cf-inner-alignment-mobile"] == "cf-left") {
      productsInnerAlignmentMobile = "justify-content: flex-start !important; text-align: left !important;"
    } else if (options["cf-inner-alignment-mobile"] == "cf-center") {
      productsInnerAlignmentMobile = "justify-content: center !important; text-align: center !important;"
    } else if (options["cf-inner-alignment-mobile"] == "cf-right") {
      productsInnerAlignmentMobile = "justify-content: flex-end !important; text-align: right !important;"
    }

    // prettier-ignore
    const mobileStyles =
      `/* mobile styles */
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-prod-hero-content-box {
        ${options["products-item-content-width-mobile"] ? 'width: ' + options["products-item-content-width-mobile"] + 'px !important;' : ''}
        ${options["cf-inner-alignment-mobile"] == "left" ? "margin-right: auto !important; margin-left: unset !important;" : ""}
        ${options["cf-inner-alignment-mobile"] == "center" ? "margin-left: auto !important; margin-right: auto !important;" : ""}
        ${options["cf-inner-alignment-mobile"] == "right" ? "margin-left: auto !important; margin-right: unset !important;" : ""}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-prod-hero-image-box {
        ${options["products-item-image-max-width-mobile"] ? 'max-width: ' + options["products-item-image-max-width-mobile"] + 'px !important;' : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-products-subscription-radio-wrapper {
        ${options["cf-inner-alignment-mobile"] == "center" ? "margin-left: auto !important; margin-right: auto !important;" : ""}
        ${options["cf-inner-alignment-mobile"] == "right" ? "margin-left: auto !important; margin-right: unset !important;" : ""}
        ${options["cf-inner-alignment-mobile"] == "left" ? "margin-right: auto !important; margin-left: unset !important;" : ""}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-products-item-title,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-products-item-description,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-prod-hero-content-box,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-products-options-wrapper,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-quantity-picker-label,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-variant-picker-label,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-products-subscription-label,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-content-type {
        ${productsInnerAlignmentMobile ? productsInnerAlignmentMobile : ""}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-products-outer {
        ${productsOuterAlignmentMobile ? productsOuterAlignmentMobile : ""}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-product-hero-outer-button {
        ${options["button-width-mobile"] == "cf-full-width" ? "width: 100% !important;" : "width: auto !important;"}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-button {
        ${productButtonWidthMobile ? productButtonWidthMobile : ""}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-quantity-picker-label,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-variant-picker-label,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-subscription-label {
        ${productsContentLabelFontSizeMobile ? `font-size: ${productsContentLabelFontSizeMobile}px !important;` : ""}
        ${productsContentLabelLineHeightMobile ? `line-height: ${productsContentLabelLineHeightMobile}px !important;` : ""}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-quantity-picker-wrapper {
        ${quantityPickerButtonMinimumWidthMobile ? `width: ${quantityPickerButtonMinimumWidthMobile}px !important;` : ""}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-reviews {
        ${reviewsFontSizeMobile ? `font-size: ${reviewsFontSizeMobile}px !important;` : ""}
      }
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-reviews-stars-inner .svg-inline--fa {
        ${reviewsStarSizeMobile ? `font-size: ${reviewsStarSizeMobile}px;` : ""}products-hero-subscription-corner-rounding
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element div.cf-products-subscription-dropdown-wrapper select,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-subscription-radio-wrapper label,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-subscription-plan-price-column {
        ${subscriptionChoicesFontSizeMobile ? `font-size: ${subscriptionChoicesFontSizeMobile}px !important;` : ""}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-item-title p {
        ${options["products-title-max-number-of-lines-mobile"] ? `-webkit-line-clamp: ${options["products-title-max-number-of-lines-mobile"]}; display: -webkit-box !important;` : ''}
        ${options["products-title-max-number-of-lines-mobile"] ? `line-clamp: ${options["products-title-max-number-of-lines-mobile"]};` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-item-description {
        ${options["products-description-max-number-of-lines-mobile"] ? `-webkit-line-clamp: ${options["products-description-max-number-of-lines-mobile"]};` : ''}
        ${options["products-description-max-number-of-lines-mobile"] ? `line-clamp: ${options["products-description-max-number-of-lines-mobile"]}; display: -webkit-box !important;` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-item-description,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-item-description p,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-item-description h1,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-item-description h2,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-item-description h3,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-item-description h4,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-empty-message p {
        ${options["products-item-description-line-height-mobile"] ? `line-height: ${options["products-item-description-line-height-mobile"]}px !important;` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-product-content-type {
        ${contentTypeSpacingMobile ? `margin-bottom: ${contentTypeSpacingMobile}px !important;` : ""}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-product__image {
        ${productImageCarouselHeightMobile ? `height: ${productImageCarouselHeightMobile}px;` : ""}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-increment-quantity-picker {
        ${quantityPickerFontSizeMobile ? `font-size: ${quantityPickerFontSizeMobile}px !important;` : ""}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element div.cf-variant-picker-wrapper select,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element div.cf-variant-picker-wrapper.cf-product-content-type > div > select {
        ${variantPickerFontSizeMobile ? `font-size: ${variantPickerFontSizeMobile}px !important;` : "font-size: 12px;"}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-option-item {
        ${variantPickerOptionsMinimumWidthMobile ? `min-width: ${variantPickerOptionsMinimumWidthMobile}px !important;` : ""}
        ${variantPickerFontSizeMobile ? `font-size: ${variantPickerFontSizeMobile}px !important;` : ""}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-item {
        ${outerPaddingMobile ? 'padding: ' + outerPaddingMobile + ' !important;' : ''}
        ${verticalMarginMobile ? 'margin-bottom: ' + verticalMarginMobile + ' !important;' : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-product-hero-inner {
        display: flex !important;
        margin-left: auto;
        margin-right: auto;
        ${options["products-item-width-mobile"] ? 'width: ' + options["products-item-width-mobile"] + 'px !important;' : ''}
        ${productLayoutMobile == "cf-left" ? "flex-direction: column-reverse !important;" : "flex-direction: column !important;"}
        ${innerPaddingMobile ? 'padding: ' + innerPaddingMobile + ' !important;' : ''}
        ${options["products-horizontal-spacing-mobile"] ? 'gap: ' + options["products-horizontal-spacing-mobile"] + 'px !important;' : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-prod-hero-inner-box:has(.cf-prod-hero-image-box) {
        position: static;
        align-self: auto;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-item-image img, #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-item-image svg {
        ${options["products-item-image-height-mobile"] ? 'height: ' + options["products-item-image-height-mobile"] + 'px !important;' : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-item-badge {
        ${imageBadgeFontSizeMobile ? `font-size: ${imageBadgeFontSizeMobile}px !important;` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-item-title p {
        ${options["products-item-title-size-mobile"] ? 'font-size: ' + options["products-item-title-size-mobile"] + 'px !important;' : ''}
        ${options["products-item-title-line-height-mobile"] ? 'line-height: ' + options["products-item-title-line-height-mobile"] + 'px !important;' : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-item-price p {
        ${options["products-item-price-size-mobile"] ? 'font-size: ' + options["products-item-price-size-mobile"] + 'px !important;' : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-item-description,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-item-description p,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-item-description h1,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-item-description h2,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-item-description h3,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-item-description h4,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-empty-message p {
        ${options["products-item-description-size-mobile"] ? 'font-size: ' + options["products-item-description-size-mobile"] + 'px !important;' : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-button p,
      #cta_${cta.id} .cf-button[data-element-id="${element.id}"] p {
        ${buttonFontSizeMobile ? `font-size: ${buttonFontSizeMobile}px !important;` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-products-all-button-outer .cf-button p,
      #cta_${cta.id} .cf-products-all-button-outer .cf-button[data-element-id="${element.id}"] p {
        ${options["products-add-all-btn-font-size-mobile"] ? `font-size: ${options["products-add-all-btn-font-size-mobile"]}px !important;` : ""}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-prod-hero-inner-box {
        margin-left: auto;
        margin-right: auto;
        flex-grow: 1;
        flex-basis: auto;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-prod-hero-inner-box,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-product-hero-element .cf-prod-hero-content-box {
        max-width: 100%;
        overflow: hidden;
      }
      `;

    if (builder !== true) {
      return desktopStyles + "@media (max-width: 599px) {" + mobileStyles + "}";
    } else {
      if (device == "desktop") {
        return desktopStyles;
      } else {
        return desktopStyles + mobileStyles;
      }
    }
};
